import React, { Component } from "react";
import LocationSearchForm from "./LocationSearchForm";
import LocationsSideNav from "./LocationsSideNav";
import Map from "./Map";

class AddLocations extends Component {
  render() {
    return (
      <div className="add-locations">
        <div className="" />
        <div className="form-container">
          <h2>Search for a Location in the UK</h2>
          <LocationSearchForm
            checkCityTest={this.props.checkCityTest}
            formResponse={this.props.formResponse}
            formMsg={this.props.formMsg}
          />
        </div>
        <div id="locations-container">
          <LocationsSideNav
            items={this.props.items}
            checkDelete={this.props.checkDelete}
          />
        </div>
      </div>
    );
  }
}

export default AddLocations;
